const Option = ({ clsn, on_click_func, opt_name, key_cls, start_rt_ref, prc_rt_ref, expander_width }) => {

  return (
    <div
      className={clsn}
      onClick={(e) => on_click_func(e)}
    >
      <h4>
        {opt_name}
        <span className="key">[ option&nbsp;{key_cls}&nbsp;]</span>
      </h4>
      <div className="ratio">
        <p className="starting_rt">{start_rt_ref}</p>
        <p className="precentage_rt" ref={prc_rt_ref}>
          <span className="expander" style={{width: expander_width}}></span>
        </p>
        <p className="ending_rt">100%</p>
      </div>
    </div>
  );
}

export default Option;